import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { TmBaseComponent } from '..';
import { LabeledList } from '../view-models';

export const tagName = 'tm-labeled-list';
@customElement(tagName)
export class TmLabeledList<T> extends TmBaseComponent {
    @property({ attribute: false, reflect: false })
    public list?: LabeledList<T>;

    @property({ attribute: false })
    protected readonly verifiedPropNames: (keyof this)[] = ['list'];

    protected render() {
        if (!this.list) {
            return nothing;
        }

        return html`<div class="grid grid-cols-[auto_1fr] gap-x-3 text-sm">
            ${this.list.items.map(d => {
                if (d.label === 'Divider') {
                    return renderDivider(d);
                }

                return html`
                    <div class="text-left mr-3 py-1 text-secondary">${d.label}</div>
                    <div
                        @click=${() => {
                            if (d.clickEventName) {
                                this.handleEvent(d.clickEventName);
                            }
                        }}
                        @keyup=${(e: KeyboardEvent) => {
                            if (e.key === 'Enter' && d.clickEventName) {
                                this.handleEvent(d.clickEventName);
                            }
                        }}
                        class="${getTextClass()} text-left py-1 max-w-full break-all"
                    >
                        ${getContent()}
                    </div>
                `;

                function getTextClass() {
                    if (d.value) {
                        return d.clickEventName ? 'text-action cursor-pointer' : 'text-primary';
                    } else {
                        return 'text-tertiary';
                    }
                }

                function getContent() {
                    if (d.value) {
                        return Array.isArray(d.value)
                            ? d.value.map(e => html`${e}<br />`)
                            : d.value;
                    } else {
                        return 'none';
                    }
                }
            })}
        </div>`;
    }

    private handleEvent(event: string) {
        this.dispatchEvent(
            new CustomEvent(event, {
                bubbles: true,
                composed: true,
            })
        );
    }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function renderDivider(item: any) {
    return html`<div
        class=${classMap({
            'col-span-2 my-4 border-t': true,
            'border-dashed': item.value === 'dashed',
            'border-dotted': item.value === 'dotted',
        })}
    ></div>`;
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmLabeledList<unknown>;
    }
}
